<template>
  <div class="cart-section-title">
    <slot />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.cart-section-title {
  color: #555;
  font-size: 18px;
  font-weight: bold;
  line-height: 1;
  margin: 40px 16px 8px;
}
</style>
